import { useAuth } from '@/shared/contexts/AuthContext';

/**
 * Custom hook that checks if user has BOTH Firebase auth AND MongoDB profile.
 * Returns true only when user is "fully logged in".
 *
 * Profile/role data is centralized in AuthContext — this hook is a
 * convenience wrapper that preserves the existing API.
 */
const useFullAuth = () => {
    const {
        user,
        loading: authLoading,
        hasProfile,
        profileLoading,
    } = useAuth();

    const isFullyAuthenticated =
        !!user && !!user.emailVerified && hasProfile === true;
    const loading = authLoading || profileLoading;

    return {
        user: isFullyAuthenticated ? user : null,
        loading,
        isFullyAuthenticated,
    };
};

export default useFullAuth;
